import { Button, Col, Divider, Drawer, Row } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getIntl } from "../../../../../utils/intl";
import ChatInput from "./ChatInput";
import Conversation, { WelcomyMessage } from "./Conversation";
import { AiChatTranslations } from "./translations";
import { isMobileDevice } from "../../../../../utils/isMobileDevice";

function AiChat(props) {
  const [openDrawer, setOpenDrawer] = useState(false);
  const intl = getIntl();
  const location = useLocation();
  const conversationRef = useRef(null);
  const conversationRefMobile = useRef(null);
  const conversationState = useSelector(
    (state) => state.pdfConversation.conversation
  );

  // Access the query parameters from the location object
  const queryParams = new URLSearchParams(location.search);
  // Get the value of the "file" parameter
  const fileParam = queryParams.get("file");
  const aiChatId = queryParams.get("cid");

  const isMobile = isMobileDevice();

  /**
   * Responsible for scrolling to the newest message from the chat.
   */
  useEffect(() => {
    if (conversationState.length > 0) {
      if (conversationRef.current !== null) {
        conversationRef.current.scrollTop =
          conversationRef.current.scrollHeight;
      }
      if (conversationRefMobile.current !== null) {
        conversationRefMobile.current.scrollTop =
          conversationRefMobile.current.scrollHeight;
      }
    }
  }, [conversationState]);

  return (
    <div
      className="ai-chat__wrapper"
      style={isMobile ? { height: "100%" } : {}}
    >
      {!isMobile && (
        <Row className="pdf-column">
          <Col xs={24} lg={12}>
            <div className="ai-chat__pdf">
              <object
                className="pdf__wrapper"
                data={fileParam}
                type="application/pdf"
              >
                <p>
                  <a href={fileParam}>
                    <div className="pdf-load-error">
                      {intl.formatMessage(AiChatTranslations.pdfLoadError)}
                    </div>
                  </a>
                </p>
              </object>
            </div>
          </Col>
          <Col xs={0} lg={12}>
            <div class="conversation__wrapper">
              <Row className="ai-chat__messages" ref={conversationRef}>
                <Col xs={24}>
                  <div>
                    <Divider plain>
                      {intl.formatMessage(AiChatTranslations.newChat)}
                    </Divider>
                    <Conversation />
                  </div>
                </Col>
              </Row>
              <Row className="ai-chat__input">
                <Col xs={24}>
                  <ChatInput aiChatId={aiChatId} />
                </Col>
              </Row>
            </div>
          </Col>

          <div className="drawer-button">
            <Button
              type="primary"
              block
              shape="round"
              onClick={() => setOpenDrawer(!openDrawer)}
            >
              {intl.formatMessage(AiChatTranslations.openButton)}
            </Button>
          </div>

          <Drawer
            className="chat-drawer"
            visible={openDrawer}
            placement="bottom"
            height="70%"
            title="Welcomy AI Assistant"
            onClose={() => setOpenDrawer(!openDrawer)}
          >
            <Row
              className="ai-chat__messages--mobile"
              ref={conversationRefMobile}
            >
              <Col xs={24}>
                <Divider plain>
                  {intl.formatMessage(AiChatTranslations.newChat)}
                </Divider>
                <Conversation />
              </Col>
            </Row>
            <Row className="ai-chat__input--mobile">
              <Col xs={24}>
                <ChatInput aiChatId={aiChatId} />
              </Col>
            </Row>
          </Drawer>
        </Row>
      )}
      {isMobile && (
        <div className="chat-drawer" style={{ height: "100dvh" }}>
          <Row
            className="ai-chat__messages--mobile"
            ref={conversationRefMobile}
            style={
              isMobile
                ? { minHeight: "calc(100% - (10% + 24px))", padding: "12px" }
                : {}
            }
          >
            <Col xs={24}>
              <Divider plain>
                {intl.formatMessage(AiChatTranslations.newChat)}
              </Divider>
              {!fileParam && (
                <WelcomyMessage
                  message={
                    <>
                      <span>{intl.formatMessage(AiChatTranslations.referenceMessage)}</span>
                      <span>
                        <a href={fileParam}>{intl.formatMessage(AiChatTranslations.referenceMessageLink)}</a>
                      </span>
                    </>
                  }
                  key={`document-reference`}
                />
              )}
              <Conversation />
            </Col>
          </Row>
          <Row
            className="ai-chat__input--mobile"
            style={isMobile ? { minHeight: "calc(10% + 24px)" } : {}}
          >
            <Col xs={24}>
              <ChatInput aiChatId={aiChatId} />
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
}

export default AiChat;
